import React from 'react';
import { connect } from 'react-redux';
import { List as IList } from 'immutable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Container } from 'cstar-react-primitives/lib/redux-form/layout/Container';

import { newItemCurrency } from '../item/newItemForm';
import { getPaidItemsCount } from '../item/itemSelectors';
import {
    getElectronicCurrencyList,
    getPlasticCurrencyList,
    getDefaultItemDigitalCurrency,
    getDefaultItemPlasticCurrency
} from '../catalogs/catalogSelectors';

import CardTypeForm from './CardTypeForm';
import cardTypeMessages from './cardTypeMessages';


export const CardTypeStep = ({
    intl,
    showCurrencyPicker,
    allowChangingCurrency,
    isPlastic,
    submitAction,
    getSubmitMessage,
    selectedElectronicCurrency,
    selectedPhysicalCurrency,
    electronicCurrencyList,
    physicalCurrencyList,
    currentCurrency
}) => (
    <Container heading={intl.formatMessage(cardTypeMessages.heading)}>
        <CardTypeForm
            cashbotName="cardType"
            isPlastic={isPlastic}
            showCurrencyPicker={showCurrencyPicker}
            allowChangingCurrency={allowChangingCurrency}
            selectedElectronicCurrency={selectedElectronicCurrency}
            selectedPhysicalCurrency={selectedPhysicalCurrency}
            submitAction={submitAction}
            getSubmitMessage={getSubmitMessage}
            electronicCurrencyList={electronicCurrencyList}
            physicalCurrencyList={physicalCurrencyList}
            currentCurrency={currentCurrency}
        />
    </Container>
);

CardTypeStep.defaultProps = {
    
    
    selectedElectronicCurrency: null,
    selectedPhysicalCurrency: null,
    isPlastic: false,
    showCurrencyPicker: false,
    allowChangingCurrency: false
};

CardTypeStep.propTypes = {
    
    intl: intlShape.isRequired,
    
    isPlastic: PropTypes.bool,
    submitAction: PropTypes.func.isRequired,
    getSubmitMessage: PropTypes.func.isRequired,
    
    showCurrencyPicker: PropTypes.bool,
    allowChangingCurrency: PropTypes.bool,
    selectedElectronicCurrency: PropTypes.string,
    selectedPhysicalCurrency: PropTypes.string,
    electronicCurrencyList: PropTypes.instanceOf(IList).isRequired,
    physicalCurrencyList: PropTypes.instanceOf(IList).isRequired,
    currentCurrency: PropTypes.string.isRequired
};

export const mapStateToProps = (state) => {
    const electronicCurrencyList = getElectronicCurrencyList(state);
    const physicalCurrencyList = getPlasticCurrencyList(state);
    const showCurrencyPicker = electronicCurrencyList.size > 1
        || !electronicCurrencyList.equals(physicalCurrencyList);

    return {
        showCurrencyPicker,
        allowChangingCurrency: getPaidItemsCount(state) === 0,
        selectedElectronicCurrency: getDefaultItemDigitalCurrency(state),
        selectedPhysicalCurrency: getDefaultItemPlasticCurrency(state),
        electronicCurrencyList,
        physicalCurrencyList,
        currentCurrency: newItemCurrency(state)
    };
};

export default connect(mapStateToProps)(injectIntl(CardTypeStep));
